import { render, staticRenderFns } from "./msr.vue?vue&type=template&id=b23f01ec&scoped=true&"
import script from "./msr.vue?vue&type=script&lang=js&"
export * from "./msr.vue?vue&type=script&lang=js&"
import style0 from "./msr.vue?vue&type=style&index=0&id=b23f01ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23f01ec",
  null
  
)

export default component.exports